import { CheckBox, Label } from '@iwoca/orion';
import { Column } from '@tanstack/react-table';
import clsx from 'clsx';
import { FilterActionButtons } from 'components/FilterActionButtons/FilterActionButtons';
import { TApplication } from 'lendingApi/applications.types';
import styles from './SelectColumnFilter.module.css';
import { useSelectColumnFilter } from './useSelectColumnFilter.hook';

type TProps = {
  column: Column<TApplication, unknown>;
  onClose: () => void;
};

export const SelectColumnFilter = ({ column, onClose }: TProps) => {
  const {
    groupedItems,
    selectedValues,
    handleChange,
    handleReset,
    handleApply,
  } = useSelectColumnFilter({
    column,
    onClose,
  });

  return (
    <>
      <div className={styles.items}>
        {groupedItems.map(({ group, items }) => (
          <div
            key={group}
            className={clsx(styles.group, {
              ungrouped: group === 'ungrouped',
            })}
          >
            {group !== 'ungrouped' && (
              <h4 className={styles.groupTitle}>{group}</h4>
            )}
            {items.map(({ value, label }) => (
              <div className={styles.filterItem} key={value}>
                <CheckBox
                  id={group + value}
                  name={value}
                  checked={selectedValues.includes(value)}
                  onChange={handleChange}
                  data-testid={`${value}-checkbox`}
                />
                <Label htmlFor={group + value} className={styles.filterLabel}>
                  {label || value}
                </Label>
              </div>
            ))}
          </div>
        ))}
      </div>
      <FilterActionButtons
        onResetClick={handleReset}
        onApplyClick={handleApply}
      />
    </>
  );
};
